<template>
    <div class="cancel-modal-question">
        <div class="question-box">
            <onboarding-counter
                :step="step"
                :total-steps="3"
            />
            <transition-group
                name="fade"
                mode="out-in"
            >
                <div v-if="loading" key="loader">
                    <i class="fas fa-spinner fa-spin loader" />
                </div>
                <error v-else-if="hasRequestError" key="error" />
                <question-content
                    v-else
                    key="question"
                    ref="question"
                    :control="controls[step - 1]"
                    :step="step"
                />
            </transition-group>
            <div class="question-controls">
                <base-submit-button
                    class="btn btn-primary"
                    :loading="formProcessing"
                    @click="saveAnswer"
                >
                    <template v-if="3 !== step">
                        Next Question
                    </template>
                    <template v-else>
                        Thanks!
                    </template>
                </base-submit-button>
                <span
                    v-if="3 !== step"
                    class="cancel-link"
                    @click="skipQuestion"
                >
                    Skip
                </span>
            </div>
        </div>
        <register-testimonial />
    </div>
</template>

<script>
import apiCall from '@/utils/apiCall';
import suspendUser from '@/utils/user/suspendUser';
import Error from '@/components/Dashboard/Onboarding/Error';
import { mapMutations, mapActions, mapState } from 'vuex';
import RegisterTestimonial from '@/components/Register/RegisterTestimonial';
import QuestionContent from './QuestionContent.vue';
import OnboardingCounter from '@/components/Dashboard/Onboarding/OnboardingCounter';
import toasts from '@/mixins/toasts';

export default {
    components: {
        RegisterTestimonial,
        QuestionContent,
        OnboardingCounter,
        Error,
    },

    mixins: [toasts],

    data: () => ({
        step: 1,
        formProcessing: false,
        controls: [],
        loading: true,
    }),

    computed: {
        ...mapState([
            'user',
            'hasRequestError',
            'userSubscription',
        ]),
    },

    /**
     * Created hook
     */
    created() {
        apiCall(this, 'get', `${this.$appUrl}/api/user/profile-controls/offboarding`)
            .then((response) => {
                if (200 === response.status && response.data) {
                    this.controls = response.data;
                    this.loading = false;
                } else {
                    this.setRequestError();
                }
            })
            .catch(this.setRequestError)
            .finally(() => {
                this.loading = false;
            });
    },

    methods: {
        ...mapActions([
            'setUserMeta',
            'updateUser',
        ]),
        ...mapMutations([
            'setRequestError',
            'changeUIState',
        ]),

        /**
         * Proceed to next question
         */
        async nextQuestion() {
            if (3 !== this.step) {
                this.step++;
            } else {
                await this.setUserMeta({ offboarding_finished: Date.now() });
                suspendUser(this);
            }
        },

        /**
         * Save user answer
         */
        saveAnswer() {
            const { answer } = this.$refs.question._data;
            const metaKey = this.controls[this.step - 1].name;

            const meta = {
                [metaKey]: answer,
            };

            this.formProcessing = true;

            this.setUserMeta(meta)
                .then(() => {
                    this.nextQuestion();
                    this.formProcessing = false;
                });
        },

        /**
         * Skip question
         */
        skipQuestion() {
            this.nextQuestion();
        },
    },
};
</script>
